import axios from 'axios';
import { Category, FullArticle, NoContentArticle, PrinFormDTO, Tag } from './knowledge-base.type';

const TAGS_ROOT = '/tags';
const PRINT_FORM_URL = '/services/isnaportal/open-api/knowledge-base/export-pdf';

const getEntitiesByParent = async <Entity>(serviceUrl: string, parent: string) => {
    const res = await axios.get<Entity>(serviceUrl, { params: { parent } });
    return res.data;
};

export const getCategoriesApi = getEntitiesByParent<Category[]>;
export const getArticlesApi = getEntitiesByParent<NoContentArticle[]>;
export const getTagsApi = async (serviceUrl: string) =>
    getEntitiesByParent<Tag[]>(serviceUrl, TAGS_ROOT);

export const updateRating = async (serviceUrl: string, id: string, score: number) => {
    const res = await axios.get<FullArticle>(serviceUrl, { params: { id, score } });
    return res.data;
};

export const getPrintForm = async (body: PrinFormDTO, { lang }: { lang: string }) => {
    return axios.post<Blob>(PRINT_FORM_URL, body, {
        params: { print: true, lang },
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/pdf',
        },
    });
};
